@if (toast(); as message) {
<tds-toast
  [toastId]="message.id"
  [header]="message.header"
  [subheader]="message.subheader"
  [variant]="message.variant"
  [closable]="true"
  tdsCloseAriaLabel="Fechar"
  (tdsClose)="close()"
></tds-toast>
}
